import { useWebSocketStore } from '@autobid/nuxt-pinia-store/store/useWebSocketStore'
import { AUCTION_CARS_SOCKET_CALLBACK } from '@autobid/ui/composables/car/sockets/useAuctionCarsSocket'
import { useUpdateCar } from '@autobid/ui/composables/car/useUpdateCar'

export function useAuctionCarsCarReserved() {
  const { startListen } = useWebSocketStore()
  const { updateAuctionCar } = useUpdateCar()

  const carReserved = () => {
    startListen({
      eventName: 'premium.CAR_RESERVED',
      callbackName: AUCTION_CARS_SOCKET_CALLBACK,
      callback: (event) => {
        const { carId } = event.context

        updateAuctionCar('unknown', carId, (data) => {
          return {
            ...data,
            state: 'RESERVED',
          }
        })
      },
    })
  }

  return { carReserved }
}
